import { F0TagBalance } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface PeriodBalanceTagProps {
  currentPeriodAmount: number
  lastPeriodAmount: number
}

const calculatePercentageDifference = (current: number, last: number): number => {
  if (last === 0) return 0
  return ((current - last) / last) * 100
}

const PeriodBalanceTag = ({ currentPeriodAmount, lastPeriodAmount }: PeriodBalanceTagProps) => {
  const notApplicableSpecialCase = lastPeriodAmount === 0

  const percentage = notApplicableSpecialCase
    ? null
    : calculatePercentageDifference(currentPeriodAmount, lastPeriodAmount)
  return (
    <>
      <F0TagBalance
        amount={{
          numericValue: {
            value_x100: currentPeriodAmount,
          },
          formatterOptions: {
            decimalPlaces: 2,
          },
        }}
        nullText={i18n.t(
          'expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change'
        )}
        percentage={percentage}
        hint={i18n.t(
          'expenses_v2.reports.expenses_by_approval_status.common.change_from_last_period',
          {
            percentage: percentage
              ? {
                  number: percentage,
                  decimalPlaces: 2,
                }
              : undefined,
          }
        )}
        info={
          notApplicableSpecialCase
            ? i18n.t(
                'expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change_explanation'
              )
            : undefined
        }
      />
    </>
  )
}

export default PeriodBalanceTag
